import { Component, OnInit } from '@angular/core';
import {TableHeaderService} from '../../../resources/services/table-header.service';
import {ActivatedRoute, Routes} from '@angular/router';
import {StoreAppService} from '../../../resources/services/store-app.service';
import {StoreViewRoutes} from "./store-view.routes";
import {Subscription} from "rxjs";
import {PermissionService} from '../../../resources/services/permission.service';

@Component({
  selector: 'store-view',
  templateUrl: './store-view.component.html'
})
export class StoreViewComponent implements OnInit {

  name: string = this.route.snapshot.data.breadcrumbs;
  id: any;
  item: any;
  routes: Routes = StoreViewRoutes;
  paramsChange: Subscription;

  constructor(private tableHeaderService: TableHeaderService,
              private route: ActivatedRoute,
              private modelService: StoreAppService) {
    this.paramsChange = this.route.params.subscribe(params => {
      this.id = params['id'];
    });
  }

  ngOnInit(): void {
    this.get();
  }

  ngOnDestroy() {
    this.paramsChange.unsubscribe();
  }

  get(): void {
    this.modelService.get({id: this.id})
      .subscribe((res: any) => {
          this.item = res;
        },
        err => {
        }
      );
  }
}
